/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Last_UpdatedInputs */

const en_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: August 31, 2026`)
};

const de_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand: 31. August 2026`)
};

const fr_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour : 31 août 2026`)
};

const es_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización: 31 de agosto de 2026`)
};

const it_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento: 31 agosto 2026`)
};

const nl_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt: 31 augustus 2026`)
};

const pl_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja: 31 sierpnia 2026`)
};

const fi_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitetty viimeksi 31. elokuuta 2026`)
};

const da_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senest opdateret: 31. august 2026`)
};

const sv_agb_last_updated = /** @type {(inputs: Agb_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad: 31 augusti 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: August 31, 2026" |
*
* @param {Agb_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_last_updated = /** @type {((inputs?: Agb_Last_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Last_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_last_updated(inputs)
	if (locale === "fr") return fr_agb_last_updated(inputs)
	if (locale === "es") return es_agb_last_updated(inputs)
	if (locale === "it") return it_agb_last_updated(inputs)
	if (locale === "nl") return nl_agb_last_updated(inputs)
	if (locale === "pl") return pl_agb_last_updated(inputs)
	if (locale === "fi") return fi_agb_last_updated(inputs)
	if (locale === "da") return da_agb_last_updated(inputs)
	if (locale === "sv") return sv_agb_last_updated(inputs)
	return en_agb_last_updated(inputs)
});